import ChartGenerator from "../../../../../js/chart/ChartGenerator";
import _ from "underscore";
import LeaveTypeStore from "../../../../../js/store/LeaveTypeStore";
import {getMaxScaleValue, getVerticalGridCount} from "../../../../../js/chart/utils";

function LeaveTimeChartGenerator(){}

LeaveTimeChartGenerator.prototype = _.create(ChartGenerator.prototype, {
    MAX_VERTICAL_GRIDS: 6,

    _prepareChartSettings: function(chartData, config)
    {
        var leaveTypesIds = config["leaveTypesIdsOrdered"];
        var collectedData = this._getCollectedData(chartData);

        var colorScheme = config["colorScheme"];
        var chartScrollbar = this._getChartScrollbar(chartData, config);

        var categoryAxisLabelFunction = config["categoryAxisLabelFunction"];
        var valueAxisLabelFunction = config["valueAxisLabelFunction"];
        var categoryFormatFunctionForBalloon = config["categoryFormatFunctionForBalloon"];

        var maxScaleValue = this._getMaxScaleValue(collectedData, config);
        var gridCount = getVerticalGridCount(maxScaleValue, 0, this.MAX_VERTICAL_GRIDS);
        var chartMargins = this._getMargins(valueAxisLabelFunction(maxScaleValue));

        var dataProvider = this._prepareDataProvider(collectedData, leaveTypesIds, colorScheme, valueAxisLabelFunction);

        return {
            "type": "serial",
            "autoResize": false,

            "startDuration": 0,
            "startEffect": "easeOutSine",
            "sequencedAnimation": true,

            "theme": "light",
            "columnWidth": 0.6,
            "fontSize": 11,
            "addClassNames": true,

            "autoMargins": false,
            "marginTop": chartMargins["top"],
            "marginBottom": chartMargins["bottom"],
            "marginLeft": chartMargins["left"],
            "marginRight": chartMargins["right"],

            "graphs": this._prepareChartGraphs(leaveTypesIds, colorScheme, categoryFormatFunctionForBalloon),

            "valueAxes": [
                {
                    "id": "main",
                    "maximum": maxScaleValue,
                    "autoGridCount": false,
                    "strictMinMax": true,
                    "gridCount": gridCount,
                    "labelFunction": valueAxisLabelFunction,
                    "stackType": "regular"
                },
                {
                    "id": "hidden",
                    "gridCount": 0,
                    "position": "right",
                    "synchronizeWith": "main",
                    "synchronizationMultiplier": 1,
                    "autoGridCount": false,
                    "axisAlpha": 0.11,
                    // it need for show axis if auto margin off (hack)
                    "minimum": 0,
                    "logarithmic": true
                }
            ],

            "chartCursor": {
                "oneBalloonOnly": true,
                "categoryBalloonEnabled": false,
                "balloonPointerOrientation": "horizontal",
                "cursorAlpha": 0,
                "zoomable": false
            },

            "chartScrollbar": chartScrollbar,

            "categoryField": "category",
            "categoryAxis": {
                "gridPosition": "start",
                "color": "#414141",
                "categoryFunction": categoryAxisLabelFunction,
                "labelRotation": 48,
                "labelFrequency": 1,
                "minHorizontalGap": 65,
                "minVerticalGap" : 50,
                "fontSize": 11
            },
            "dataProvider": dataProvider
        }
    },

    _getMaxScaleValue: function(collectedData, config)
    {
        var maxScaleValue;
        if (_.isUndefined(config["maxScaleValue"]))
        {
            maxScaleValue = getMaxScaleValue(collectedData.maxSummaryLeaveValue, this.MAX_VERTICAL_GRIDS);
            this._maxScaleValue = maxScaleValue;
        }
        else
        {
            maxScaleValue = config["maxScaleValue"]; // maxScaleValue from config used when chart is exporting to pdf
        }
        return maxScaleValue;
    },

    _getChartScrollbar: function(data, config)
    {
        if (!config["showScrollbar"] || data.length <= 26)
        {
            return null;
        }
        else
        {
            return {
                "scrollbarHeight": 16,
                "dragIconHeight": 30,
                "dragIconWidth": 30,
                "backgroundColor" : "#f9f9f9",
                "backgroundAlpha" : 1,
                "selectedBackgroundAlpha" : 1,
                "selectedBackgroundColor" : "#e8e8e8"
            }
        }
    },

    _prepareDataProvider: function(collectedData, leaveTypeIds, colorScheme, timeFormatFunction)
    {
        var dataProvider = [];
        var leavesData = collectedData.leavesData;
        for (var i = 0; i < leavesData.length; i++)
        {
            var leaveData = leavesData[i];
            var contextData = {};
            contextData["category"] = leaveData["category"];
            contextData["balloon"] = leaveData["total"];

            var balloonContext = {};
            balloonContext["total"] = timeFormatFunction(leaveData["total"]);
            balloonContext["category"] = leaveData["category"];

            var spentTimeByLeaveIdMap = leaveData["spentTimeByLeaveIdMap"];
            var leavesDataToShow = [];
            var nonZeroLeaveTypeValues = 0;
            for (var index = leaveTypeIds.length - 1; index >= 0; index--)
            {
                var spentTime = spentTimeByLeaveIdMap[leaveTypeIds[index]];
                contextData["value-" + leaveTypeIds[index]] = spentTime;
                if (spentTime != 0)
                {
                    nonZeroLeaveTypeValues++;
                    if (leavesDataToShow.length < 5) // only 5 leave type infos with non-zero value were shown on balloon
                    {
                        leavesDataToShow.push({
                                                  "value": timeFormatFunction(spentTime),
                                                  "leaveTypeName": LeaveTypeStore.getLeaveType(leaveTypeIds[index]).name,
                                                  "color": this._getColor(colorScheme, leaveTypeIds[index])
                                              });
                    }
                }
            }
            balloonContext["leavesDataToShow"] = leavesDataToShow;
            balloonContext["more"] = nonZeroLeaveTypeValues - leavesDataToShow.length;
            contextData["balloonContext"] = balloonContext;

            dataProvider.push(contextData);
        }
        return dataProvider;
    },

    _getCollectedData: function(items)
    {
        var maxSummaryValue = 0;
        var leavesData = [];
        for (var i = 0; i < items.length; i++)
        {
            var item = items[i];

            if (item["totalLeaveSpent"] > maxSummaryValue)
            {
                maxSummaryValue = item["totalLeaveSpent"];
            }

            var leaveData = {};
            leaveData["category"] = item["category"];

            var spentTimeByLeaveIdMap = {};
            _.each(item["leaveSpent"], function(leaveSpentObj)
            {
                spentTimeByLeaveIdMap[leaveSpentObj.leaveTypeId] = leaveSpentObj["leaveSpent"];
            });
            leaveData["spentTimeByLeaveIdMap"] = spentTimeByLeaveIdMap;
            leaveData["total"] = item["totalLeaveSpent"];
            leavesData.push(leaveData);
        }
        return {
            "maxSummaryLeaveValue": maxSummaryValue,
            "leavesData": leavesData
        };
    },

    /**
     * Prepare graphs for chart. Every graph represents one type of column
     */
    _prepareChartGraphs: function(leaveTypeIds, colorScheme, categoryFormatFunction)
    {
        var graphs = [];
        var self = this;

        _.each(leaveTypeIds, function(leaveTypeId)
        {
            graphs.push(self._createLeaveTimeDataGraph(leaveTypeId, self._getColor(colorScheme, leaveTypeId)));
        });

        var balloonGraph = {
            "showBalloon": true,
            "fillAlphas": 0,
            "lineAlpha": 0,
            "newStack": true,
            "type": "column",
            "clustered": false,
            "valueField": "balloon",
            "fillColors": "#FFFFFF",
            "balloonFunction": this._createBalloonFunction(categoryFormatFunction),
            "lineThickness": 0,
            "balloon": {
                "adjustBorderColor": false,
                "borderColor": "#b2b2b2",
                "borderThickness": 1,
                "fillAlpha": 0.85,
                "shadowAlpha": 0
            }
        };
        graphs.push(balloonGraph);
        return graphs;
    },

    /**
     * Create leave time graph
     */
    _createLeaveTimeDataGraph: function(id, color)
    {
        return {
            "showBalloon": false,
            "fillAlphas": 1,
            "lineAlpha": 0,
            "type": "column",
            "clustered": false,
            "valueField": "value-" + id,
            "fillColors": color
        }
    },

    _getMargins: function(formattedMaxScaleValue)
    {
        var left = 72;

        if (formattedMaxScaleValue.length > 8)
        {
            left += (formattedMaxScaleValue.length - 8) * 8;
        }

        return {
            "top": 20,
            "bottom": 125,
            "left": left,
            "right": 20
        }
    },

    _createBalloonFunction: function(categoryFormatFunction)
    {
        var balloonTemplate = _.template(
                "<div class='leaveTimeChartBalloon'>" +
                "   <div class='category'><%-categoryFormatFunction(category)%></div>" +
                "   <div class='totalSection'><%=messageResource.getMessage('actiplans.reports.chart.total_leave_time')%>&nbsp;<%=total%></div>" +
                "   <% _.each(leavesDataToShow, function(leaveDataToShow) { %>" +
                "     <div class='leaveType'>" +
                "       <div class='icon' style='background-color: <%=leaveDataToShow.color%>'></div>" +
                "       <div class='leaveTypeName'><%-leaveDataToShow.leaveTypeName%></div>:&nbsp;<%=leaveDataToShow.value%>" +
                "     </div>" +
                "   <% })%>" +
                "   <% if (more > 0) { %>" +
                "     <div class='more'><%=messageResource.getMessage('actiplans.reports.chart.leave_time_tooltip.more', [more])%></div>" +
                "   <% } %>" +
                "</div>"
        );

        return function(item)
        {
            return balloonTemplate(_.extend(item.dataContext["balloonContext"], {"categoryFormatFunction": categoryFormatFunction}));
        };
    },

    _getColor: function(colorScheme, leaveTypeId)
    {
        return colorScheme[LeaveTypeStore.getLeaveType(leaveTypeId).iconId];
    },

    _getAdditionalEventListeners: function()
    {
        var self = this;
        return [{
            "event": "zoomed",
            "method": function(event)
            {
                self._startIndex = event.startIndex;
                self._endIndex = event.endIndex;
            }
        }];
    },

    getExportChartConfig: function()
    {
        return {
            "startIndex": this._startIndex,
            "endIndex": this._endIndex,
            "maxScaleValue": this._maxScaleValue,
            "showScrollbar": false
        }
    },

    _updateSettingsForExport: function(settings, chartData, config)
    {
        var scales = this._getChartScales(config);
        settings["marginLeft"] *= scales.horizontal;
        settings["fontSize"] = settings["fontSize"] * scales.common;
        settings["categoryAxis"]["fontSize"] *= scales.common;
        settings["categoryAxis"]["minHorizontalGap"] *= scales.common;
        settings["categoryAxis"]["minVerticalGap"] *= scales.common;
        settings["marginBottom"] *= scales.vertical;
    }
});

export default LeaveTimeChartGenerator;



// WEBPACK FOOTER //
// ./web/actiplans/js/reports/leaveTimeBalancesReportPage/chart/LeaveTimeChartGenerator.js